const getDragSourceElement = (rootState) => rootState.dnd.sourceElement;

export default getDragSourceElement;
